import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ScenarioActions } from './scenario.actions';
import { CommonProcessTree, ScenarioDto } from '../../../../graphql/generated';

export const scenariosFeatureKey = 'scenarios';

export interface State extends EntityState<ScenarioDto> {
  // additional entities state properties
  loading: boolean,
  filters: any,
  // legalEntity: LegalEntity[],
  // valueChain: string[],
  // cpt: CptCatalogue[],
  processes: Partial<CommonProcessTree>[]
  // risks: RiskParameter[],
}

export const adapter: EntityAdapter<ScenarioDto> = createEntityAdapter<ScenarioDto>({
  selectId: (scenario: ScenarioDto) => scenario.id as string
});

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loading: false,
  filters: {},
  // legalEntity: [],
  // valueChain: [],
  // cpt: [],
  processes: []
  // risks: [],
});

export const reducer = createReducer(
  initialState,

  on(ScenarioActions.loadScenarios, (state) => ({
    ...adapter.removeAll({ ...state, loading: false })
  })),

  on(ScenarioActions.loadScenariosSuccess, (state, action) => ({
    ...adapter.setAll(action.scenarios as ScenarioDto[], state),
    loading: false
  })),

  on(ScenarioActions.loadScenariosFailure, (state, action) => ({
    ...adapter.removeAll({ ...state, loading: false })
  })
  ),
  on(ScenarioActions.loadScenariosYear, (state) => ({
    ...adapter.removeAll({ ...state, loading: false })
  })),

  on(ScenarioActions.loadScenariosYearSuccess, (state, action) => ({
    ...adapter.setAll(action.scenarios as ScenarioDto[], state),
    loading: false
  })),

  on(ScenarioActions.loadScenariosYearFailure, (state, action) => ({
    ...adapter.removeAll({ ...state, loading: false })
  })
  ),

  on(ScenarioActions.loadProcesses, (state) => ({
    ...adapter.removeAll({ ...state, loading: false })
  })),

  on(ScenarioActions.loadProcessesSuccess, (state, action) => ({
    ...state,
    processes: action.cpt.map(c => ({ code: c.code, name: c.name, processStatus: c.processStatus }))
  })),

  on(ScenarioActions.loadProcessesFailure, (state, action) => ({
    ...state,
    processes: []
  }))
);

export const scenariosFeature = createFeature({
  name: scenariosFeatureKey,
  reducer,
  extraSelectors: ({
    selectScenariosState,
    selectEntities,
    selectIds
  }) => ({
    ...adapter.getSelectors(selectScenariosState),
    selectScenariosList: createSelector(
      selectEntities,
      selectIds,
      (entities, ids) => {
        return entities ? ids.map((id) => entities[id] as ScenarioDto) as ScenarioDto[] : [] as ScenarioDto[]
      }
    )
  })
});

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
  selectScenariosList,
  selectLoading,
  selectProcesses,
  selectFilters
} = scenariosFeature;
